<template>
  <div class="layout-padding">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getData"
      title="QA 개선사항"
      desc="QA 개선사항 목록"
      ref="qa_sheet">
      <template v-slot:user>
        <button class="button" :class="{'is-primary': mine, 'is-grey': !mine}" style="width:180px"
                @click="setFilter">내 계정 관련 항목만 보기</button>
      </template>
    </admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1200"
                 @getData="getData"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="ftype" slot-scope="props">{{ ftype(props.item.location) }}</div>
      <div style="text-align: left" slot="location" slot-scope="props">{{ locationText(props.item.location) }}</div>
      <div slot="result" slot-scope="props">{{ props.item.location.result }}</div>
      <div slot="status" slot-scope="props">
        <div>{{ improveStatusText(props.item.status) }}</div>
        <div class="size-11">({{ props.item.status_time }})</div>
        <div class="flex-center" style="margin-top:4px" v-if="props.item.req_user === $store.getters.admin.id">
          <button v-if="!props.item.vUpdate" @click="props.item.vUpdate=true">상태 변경</button>
          <template v-else>
            <select v-model="improveStatus" style="margin-right:4px">
              <option v-for="optItem in improveOption" :key="'improve-item-'+optItem.value"
                      :value="optItem.value">{{ optItem.label }}
              </option>
            </select>
            <button @click="updateImprove(props.item)">변경</button>
          </template>
        </div>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import ListMixin from "../../../../mixins/ListMixin";

  export default {
    name: "QaImprove",
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
    },
    data() {
      return {
        mine: false,
        improveOption: [
          {
            label: '진행 전',
            value: 0,
          },
          {
            label: '진행',
            value: 1,
          },
          {
            label: '진행안함',
            value: 2,
          },
          {
            label: '보류',
            value: 3,
          }
        ],
        improveStatus: 1
      }
    },
    methods: {
      init() {
        this.initializing('qa_improve', 'launchpack/qa_improve');
      },
      setFilter() {
        if(this.mine) {
          delete this.filtered.mine;
          this.mine = false;
        } else {
          this.filtered.mine = this.$store.getters.admin.id;
          this.mine = true;
        }
        this.getData();
      },
      ftype(item) {
        return {
          front_action: '프론트',
          admin_feature: '백오피스',
          builder_feature: '빌더'
        }[item.type];
      },
      locationText(item) {
        let result = '';
        if (item.type === 'front_action') {
          result = `${item.location_name} > ${item.feature_name} > ${item.name}`;
        } else {
          result = `${item.location_name} > ${item.content}`;
        }

        return result;
      },
      improveStatusText(status) {
        return this.improveOption.filter(i => {
          return status === i.value
        })[0].label;
      },
      updateImprove(item) {
        this.$axios.patch(`admin/launchpack/qa_improve/${item.id}`, {'status': this.improveStatus}).then(res => {
          if (res.status === 200) {
            item.status = this.improveStatus;
            item.status_time = this.moment().format('YYYY-MM-DD HH:mm');
            item.vUpdate = false;
          }
        }).catch(() => {
          item.vUpdate = false;
          this.toast('상태변경에 실패했습니다.');
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>

</style>
